// extracted by mini-css-extract-plugin
export var carrierIcon = "_ut-0";
export var carrierLogo = "_ut-1";
export var detailsSection = "_ut-2";